import * as demoBrandFns from "./demoBrand";
import { createMockProduct } from "../mockCore";

const alreadyReturnedProduct = {
    product: createMockProduct({
        id: 11,
        productName: "Brown coat",
        imageSrc: "/mocks/brown_coat.png",
        returnId: 123,
        returnDate: "2022-08-08T06:29:55.639Z",
        purchasePrice: 499,
        properties: [
            {
                type: "Size",
                value: "XS",
            },
            {
                type: "Color",
                value: "Brown",
            },
            {
                type: "Type",
                value: "Long",
            },
        ],
    }),
};

export function getProducts(props) {
    const products = demoBrandFns.getProducts(props);
    products.resaleActive = true;
    products.refundOptions = [
        {
            type: "BASIC",
        },
        {
            type: "GIFT_CARD",
            bonusPercentage: 0.2,
        },
    ];
    products.products = products.products.concat(alreadyReturnedProduct.product);
    // Just to see all images and all texts for all alternatives
    // products.shipmentSolutions = Object.keys(SHIPMENT_CARRIERS).flatMap((carrier) => {
    //     return Object.keys(SHIPMENT_SOLUTION_TYPES).map((shipmentType) => {
    //         return {
    //             carrier: carrier,
    //             type: shipmentType,
    //             cost: 85.9,
    //         };
    //     });
    // });
    return products;
}
